import _ from 'lodash'
import moment from 'moment'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { goBack, push } from 'react-router-redux'

import { clearCommentErrors, createComment, listComments, setCommentErrors } from '../actions/comment'
import { clearDefectErrors, readDefect, setDefectCurrentField, setDefectErrors, updateDefect } from '../actions/defect'
import { clearFile, setFiles } from '../actions/file'
import { clearUserKey, listUsers, setUserIsLoading, setUserSelected } from '../actions/user'

import DefectEdit from '../components/DefectEdit'

class DefectEditPage extends Component {
  componentDidMount () {
    const { clearDefectErrors, readDefect, match, listComments, clearUserKey, clearFile } = this.props
    clearDefectErrors()
    readDefect(match.params.id)
    listComments(match.params.id)
    clearUserKey('assigneeUser')
    clearFile('comment-add')
    clearFile('comment-add-data')
  }

  render () {
    return (<DefectEdit {...this.props}/>)
  }
}

const mapStateToProps = (state, ownProps) => {
  const { current } = state.defect
  const props = {
    errors: _.get(state, 'defect.errors', {}),
    assignee: _.get(state, 'user.assignee', {
      isLoading: false,
      list: { rows: [] },
      selected: current ? [current.assigneeUser] : [],
      defaultSelected: current ? [current.assigneeUser] : []
    }),
    comments: _.get(state, 'comment.list.rows', []),
    commentErrors: state.comment.errors || {},
    commentImages: state.file['comment-add'],
    commentImageData: state.file['comment-add-data'],
  }
  if (current) {
    props.initialValues = { ...current }
    props.expectedDeliveryDate = current.expectedDeliveryDate ? moment(current.expectedDeliveryDate) : undefined
  }
  return props
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  readDefect (id) {
    dispatch(readDefect(id))
  },
  async onSubmit (values, expectedDeliveryDate, assignee) {
    const errors = {}
    if (!assignee) {
      errors.assignee = 'Assignee is required.'
    }
    if (!expectedDeliveryDate || !expectedDeliveryDate.isValid()) {
      errors.expectedDeliveryDate = 'Expected Delivery Date is required.'
    } else if (values.status === 'OPEN') {
      values.status = 'ACCEPT'
    }
    
    if (!_.isEmpty(errors)) {
      dispatch(setDefectErrors(errors))
      return
    }
    dispatch(clearDefectErrors())
    await dispatch(updateDefect({
      ...values,
      expectedDeliveryDate,
      assigneeUserId: assignee.id,
    }))
    dispatch(push('/defect'))
  },
  clearDefectErrors () {
    dispatch(clearDefectErrors())
  },
  clearFile (key) {
    dispatch(clearFile(key))
  },
  async searchUser (name, key) {
    dispatch(setUserIsLoading(true, key))
    await dispatch(listUsers({ name }, key))
    dispatch(setUserIsLoading(false, key))
  },
  setUserSelected (selected, key) {
    dispatch(setUserSelected(selected, key))
  },
  clearUserKey (key) {
    dispatch(clearUserKey(key))
  },
  onExpectedDeliveryDateChanged (value) {
    dispatch(setDefectCurrentField('expectedDeliveryDate', value ? value : undefined))
  },
  listComments (defectId) {
    dispatch(listComments({ defectId, limit: -1 }))
  },
  goBack () {
    dispatch(goBack())
  },
  async onCommentSubmit (values, images, reset) {
    const errors = {}
    if (!values.comment) {
      errors.comment = 'Comment is required.'
    }
    if (!_.isEmpty(errors)) {
      dispatch(setCommentErrors(errors))
      return
    }
    dispatch(clearCommentErrors())
    const defectId = ownProps.match.params.id
    await dispatch(createComment({
      ...values,
      source: 'COMMENT',
      defectId,
    }, images))
    reset()
    dispatch(clearFile('comment-add'))
    dispatch(clearFile('comment-add-data'))
    dispatch(listComments({ defectId, limit: -1 }))
  },
  uploadCommentImage (event) {
    const { files } = event.target
    dispatch(setFiles('comment-add', files))
    _.forEach(files, (file) => {
      const reader = new FileReader()
      reader.onloadend = (event) => {
        dispatch(setFiles('comment-add-data', [event.target.result]))
      }
      reader.readAsDataURL(file)
    })
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(DefectEditPage)


// WEBPACK FOOTER //
// ./src/containers/DefectEditPage.js